import { rand } from './encoding';

export const speedtest = () => {
    const fileSize = 800;

    return new Promise((res, rej) => {
        const xhr = new XMLHttpRequest();
        const url = `./${fileSize}KB.txt?id=${rand(10)}`;
        xhr.addEventListener('load', function transferComplete() {
            let end = window.performance.now();
            let mbps = (fileSize / (end - start)) * 8;
            xhr.removeEventListener('load', transferComplete);
            res(mbps);
        });
        xhr.addEventListener('error', function err(message) {
            console.error(message);
            xhr.removeEventListener('error', err);
            rej('Experiencing internet issues!');
        });
        let start = window.performance.now();
        xhr.open('GET', url);
        xhr.send();
    });
};
